import React from 'react'
import { Switch, Route, Redirect, useHistory } from 'react-router-dom'
import Home from './pages/Home'
import Careers from './pages/Career'
import Partners from './pages/Partner'
import Riders from './pages/Rider'
import About from './pages/AboutUs'
import Faqs from './pages/Faq'
import ContactUs from './pages/ContactUs'
import TermsAndConditions from './pages/TermsAndConditions'
import PrivacyPolicy from './pages/PrivacyPolicy.js'
import CookiesPolicy from './pages/CookiesPolicy'
import Login from './pages/Login'
import SignUp from './pages/SignUp'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import RiderRergistration from './pages/RiderRegistration'
import MyAccount from './pages/MyAccount'
import Restaurants from './pages/Restaurants'
import Partner from './pages/Partner'
import Career from './pages/Career'
import RefundPolicy from './pages/RefundPolicy'
import Disclaimer from './pages/Disclaimer'
import Maintenance from './pages/Maintenance'
import NotFound from './pages/NotFound/notfound'

import PrivateRoute from './PrivateRoute'
import { Guard } from './Guard'

import Header from './components/Header'
import Footer from './components/Footer'
import Checkout from './pages/Checkout'
import Thankyou from './pages/ThankYou'
import Track from './pages/Track'
import Receipt from './pages/Receipt'
import VerifyRider from './pages/rider/VerifyRider'
import DownloadRoadiePage from './components/riderregister/DownloadRoadiePage'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { ReactSession } from 'react-client-session'
import { LogoutAction } from './redux/actions/AuthActions'
import SingleResturant from './pages/SingleRestaurant'

function Routes(props) {
  const dispatch = useDispatch()
  const history = useHistory()

  const logOut = () => {
    dispatch(LogoutAction())
    ReactSession.remove('api_token')
    ReactSession.remove('user_id')
    ReactSession.remove('first_name')
    ReactSession.remove('last_name')
    ReactSession.remove('email')
    localStorage.clear()

    history.push('/login')
    window.location.reload()
  }

  const changeLocation = () => {
    try {
      document.getElementById('open_place_modal').click()
    } catch (error) {
      console.log(error)
    }
  }

  const [deviceToken, setDeviceToken] = useState('')
  const [theme, setTheme] = useState(
    localStorage.getItem('theme') ? localStorage.getItem('theme') : 'LIGHT',
  )

  const changeTheme = (newTheme) => {
    setTheme(newTheme)
    localStorage.setItem('theme', newTheme)
  }

  if (deviceToken !== props.deviceToken) {
    setDeviceToken(props.deviceToken)
  }
  return (
    <>
      <Header changeTheme={changeTheme} theme={theme} logOut={logOut} />
      <Switch>
        <Route
          exact
          path="/"
          render={() => <Home theme={theme} logOut={logOut} />}
        />
        <Route
          path="/about"
          render={() => <About theme={theme} logOut={logOut} />}
        />
        <Route
          path="/maintenance"
          render={() => <Maintenance theme={theme} logOut={logOut} />}
        />
        <Route
          exact
          path="/careers"
          render={() => <Careers theme={theme} logOut={logOut} />}
        />
        <Route
          exact
          path="/not-found"
          render={() => <NotFound theme={theme} logOut={logOut} />}
        />
        <Route
          path="/verify"
          render={() => <VerifyRider theme={theme} logOut={logOut} />}
        />
        <Route
          path="/partners"
          render={() => <Partners theme={theme} logOut={logOut} />}
        />
        <Route
          path="/roadies"
          render={() => <Riders theme={theme} logOut={logOut} />}
        />
        <Route
          path="/faqs"
          render={() => <Faqs theme={theme} logOut={logOut} />}
        />
        <Route
          path="/contact"
          render={() => <ContactUs theme={theme} logOut={logOut} />}
        />
        <Route
          path="/termsandconditions"
          render={() => <TermsAndConditions theme={theme} logOut={logOut} />}
        />
        <Route
          path="/privacypolicy"
          render={() => <PrivacyPolicy theme={theme} logOut={logOut} />}
        />
        <Route
          path="/cookiespolicy"
          render={() => <CookiesPolicy theme={theme} logOut={logOut} />}
        />
        <Route
          path="/login"
          render={() => <Login theme={theme} deviceToken={deviceToken} />}
        />
        <Route
          path="/signup"
          render={() => <SignUp theme={theme} logOut={logOut} />}
        />
        <Route
          path="/forgotpassword"
          render={() => <ForgotPassword theme={theme} logOut={logOut} />}
        />
        <Route
          path="/resetpassword"
          render={() => <ResetPassword theme={theme} logOut={logOut} />}
        />
        <Route
          path="/riderregistration"
          render={() => <RiderRergistration theme={theme} logOut={logOut} />}
        />
        <Route
          path="/view-profile"
          render={() => <MyAccount theme={theme} logOut={logOut} />}
        />
        <Route
          path="/restaurants"
          render={() => (
            <Restaurants
              theme={theme}
              logOut={logOut}
              changeLocation={changeLocation}
            />
          )}
        />
        <Route
          path="/single-restaurant"
          render={() => <SingleResturant theme={theme} logOut={logOut} />}
        />
        <Route
          path="/checkout"
          render={() => <Checkout theme={theme} logOut={logOut} />}
        />
        <Route
          path="/thankyou"
          render={() => <Thankyou theme={theme} logOut={logOut} />}
        />
        <Route
          path="/partner"
          render={() => <Partner theme={theme} logOut={logOut} />}
        />
        <Route
          path="/success"
          render={() => <DownloadRoadiePage theme={theme} logOut={logOut} />}
        />
        <Route
          path="/career"
          render={() => <Career theme={theme} logOut={logOut} />}
        />
        <Route
          path="/refundpolicy"
          render={() => <RefundPolicy theme={theme} logOut={logOut} />}
        />
        <Route
          path="/disclaimer"
          render={() => <Disclaimer theme={theme} logOut={logOut} />}
        />
        <Route
          path="/track-order"
          render={() => <Track theme={theme} logOut={logOut} />}
        />
        <Route
          path="/receipt-order"
          render={() => <Receipt theme={theme} logOut={logOut} />}
        />
        <Guard
          path="/user"
          token="user-token"
          routeRedirect="/user/login"
          component={PrivateRoute}
        />
        <Redirect to="/not-found" status="404" />
      </Switch>
      <Footer />
    </>
  )
}

export default Routes
